<template>
	<!-- header -->
	<header id="header">
		<div class="hInner subHeader">
			<div class="logoWrap">
				<div class="logo"><router-link to="#"></router-link></div>
				<div class="hLine"></div>
				<div class="hName">{{ globaljs?.mb_nick }}</div>
			</div>
			<button type="button" class="popup_close" @click="commonjs.winClose()"></button>
		</div>
	</header>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

if (!globaljs.getIsLogin() || !globaljs.mb_nick) {
	router.push('/logout');
}

onMounted(() => {
	//commonjs.DOMLoaded();
});
</script>